// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"TileGrid_buttonWrapper__bBAY5","title":"TileGrid_title__Fmb16"};